module.exports = {
          srcSet: "/_next/static/images/user2-146-40292ed53f6ae50c179da3cd89c807af.jpg"+" 146w",
          images:[ {path: "/_next/static/images/user2-146-40292ed53f6ae50c179da3cd89c807af.jpg",width: 146,height: 146}],
          src: "/_next/static/images/user2-146-40292ed53f6ae50c179da3cd89c807af.jpg",
          toString:function(){return "/_next/static/images/user2-146-40292ed53f6ae50c179da3cd89c807af.jpg"},
          
          width: 146,
          height: 146
        }